import { apiV2 } from "../v2";
import {
  adminUserIdRequest,
  getAdminUserResponse,
  listAdminUsersRequest,
  listAdminUsersResponse,
  putAdminUserSettingRequest,
  putAdminUserSettingResponse,
} from "./users.dto";

export const listAdminUsersApi = apiV2("GET", "/admin/users").withRequest(listAdminUsersRequest).withResponse(listAdminUsersResponse);

export const getAdminUserApi = apiV2("GET", "/admin/users/:id").withRequest(adminUserIdRequest).withResponse(getAdminUserResponse);

export const deleteAdminUserApi = apiV2("DELETE", "/admin/users/:id").withRequest(adminUserIdRequest);

export const putAdminUserSettingApi = apiV2("PUT", "/admin/users/:id/settings")
  .withRequest(putAdminUserSettingRequest)
  .withResponse(putAdminUserSettingResponse);
